import Reflux from 'reflux';
import storeUtils from '../../utils/store';

export default class EdpConfigStore extends Reflux.Store {
  static id = 'edpconfig';

  constructor () {
    super();

    this.state = {
      eventId: null,
      type: null,
      avoidSingleSeats: false,
      feeDisclaimer: false,
      pageProtection: false,
      platinum: false,
      memberTicketLimit: 0,
      ticketLimit: 0,
      urls: {}
    };

    const eventConfig = storeUtils.get('event_config');
    if (!(eventConfig instanceof Error)) {
      this.setState(eventConfig);
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/edpconfig/index.js